import script from "./PlanSelectionStep20676.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanSelectionStep20676.vue?vue&type=script&setup=true&lang=ts"

import "./PlanSelectionStep20676.vue?vue&type=style&index=0&id=0f170ad2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f170ad2"]])

export default __exports__